import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import style from './ChartDatalist.module.css';

export const ChartDataList = ({
  id,
  dataList,
  controlledValue,
  children,
  onBlurFn,
  dataListMapFn,
  backgroundColor,
}) => {
  const [inputVal, setInputVal] = useState(controlledValue);

  useEffect(() => {
    setInputVal(controlledValue);
  }, [controlledValue]);

  return (
    <>
      <input
        style={{ backgroundColor }}
        type="number"
        onFocus={() => setInputVal('')}
        list={id}
        className={style.input}
        placeholder={children}
        id={children}
        name={children}
        value={inputVal}
        onChange={({ target }) => setInputVal(target.value)}
        onBlur={() => {
          if (inputVal !== '' && inputVal !== controlledValue)
            onBlurFn(inputVal);
          else setInputVal(controlledValue);
        }}
      />
      <datalist id={id}>{dataList.map(dataListMapFn)}</datalist>
    </>
  );
};

ChartDataList.propTypes = {
  children: PropTypes.any,
  controlledValue: PropTypes.any,
  dataList: PropTypes.array,
  dataListMapFn: PropTypes.any,
  id: PropTypes.any,
  onBlurFn: PropTypes.func,
  setValue: PropTypes.any,
  backgroundColor: PropTypes.string,
};
